import { fetchAllStorageObjects } from "../../../../app/state/storageObjectSlice/actions/actions";
import { FrameComponent } from "../../../../common/FrameComponent";
import { getAccessToken } from "../../../../services/api/utils";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { BackArrowIcon } from "../../../../shared/icons/BackArrowIcon";
import { CASES_TABLE_URL } from "../../constants";
import { selectCaseMode } from "../../redux/selectors";
import { setCaseMode } from "../../redux/slice";
import styles from "./styles.module.css";

export const CasesTable = () => {
  const dispatch = useAppDispatch();
  const caseMode = useAppSelector(selectCaseMode);

  const handleBackToCreateCaseMode = () => {
    dispatch(setCaseMode(caseMode === "create" ? "table" : "create"));
    dispatch(
      fetchAllStorageObjects({ service: "cases", ignoreCondition: true }),
    );
  };

  return (
    <div className={styles["case-table-container"]}>
      <AppUnderlinedTitle
        leftContent={"Сводная таблица"}
        className={styles["case-table-header"]}
      >
        <AppIconButton onClick={handleBackToCreateCaseMode}>
          <BackArrowIcon />
        </AppIconButton>
      </AppUnderlinedTitle>
      <FrameComponent
        src={`${CASES_TABLE_URL}?user_token=${getAccessToken()}`}
      />
    </div>
  );
};
